import React from "react";

export default function Nav() {
    return (
        <section className="hero is-dark">
            <div className="hero-body">
                <h1 className="title">#askatp</h1>
                <p className="subtitle">Questions previously asked on the Accidental Tech Podcast.</p>
            </div>
        </section>
    )
}
